export const SIGNUP_PROMPT = {
  TITLE: { key: 'SIGNUP_PROMPT.TITLE', value: 'PERFECT DOC STUDIO' },
  MESSAGE: { key: 'SIGNUP_PROMPT.MESSAGE', value: '<0>Create an account</0> <1>or</1> <2>Sign in</2>' },
  MESSAGE_2: { key: 'SIGNUP_PROMPT.MESSAGE_2', value: 'to unlock premium features' },
  SIGNUP_BUTTON: { key: 'SIGNUP_PROMPT.SIGNUP_BUTTON', value: 'Sign Up' },
  CANCEL_BUTTON: { key: 'SIGNUP_PROMPT.CANCEL_BUTTON', value: 'Cancel' },
};

export const LOGOUT_MODAL = {
  LOGOUT_TITLE: { key: 'LOGOUT_TITLE', value: 'LOG OUT' },
  LOGGING_OFF_BUTTON: { key: 'LOGGING_OFF_BUTTON', value: 'Logging Off' },
  LOGOUT_BUTTON: { key: 'LOGOUT_BUTTON', value: 'LOG OUT' },
  CONFIRMATION_TEXT: {
    key: 'CONFIRMATION_TEXT',
    value: 'Are you sure you wish to Log out?',
  },
  CANCEL_LOGOUT_BUTTON: {
    key: 'CANCEL_LOGOUT_BUTTON',
    value: 'Cancel',
  },
};

export const ADD_USER_MODAL = {
  TITLE: { key: 'TITLE', value: 'Add User' },
  FIRST_NAME_LABEL: { key: 'FIRST_NAME_LABEL', value: 'First Name' },
  LAST_NAME_LABEL: { key: 'LAST_NAME_LABEL', value: 'Last Name' },
  EMAIL_LABEL: { key: 'EMAIL_LABEL', value: 'Email' },
  LDAP_USER_NAME_LABEL: { key: 'LDAP_USER_NAME_LABEL', value: 'LDAP User Name' },
  USER_ROLES_LABEL: { key: 'USER_ROLES_LABEL', value: 'Select User Roles' },
  TEAM_PERMISSIONS_LABEL: {
    key: 'TEAM_PERMISSIONS_LABEL',
    value: 'Grant team permission',
  },
  NEXT_STEP_BUTTON: { key: 'USER_NEXT_STEP_BUTTON', value: 'Next' },
  PREVIOUS_STEP_BUTTON: { key: 'PREVIOUS_STEP_BUTTON', value: 'Previous' },
  DOC_USER_BUTTON: { key: 'DOC_USER_BUTTON', value: 'Doc Studio User' },
  LDAP_USER_BUTTON: { key: 'LDAP_USER_BUTTON', value: 'LDAP User' },
  SENDING_INVITE_BUTTON: { key: 'SENDING_INVITE_BUTTON', value: 'Sending Invite' },
  INVITE_BUTTON: { key: 'INVITE_BUTTON', value: 'Invite User' },
  FIRST_NAME_PLACEHOLDER: { key: 'FIRST_NAME_PLACEHOLDER', value: 'First Name' },
  LAST_NAME_PLACEHOLDER: { key: 'LAST_NAME_PLACEHOLDER', value: 'Last Name' },
  EMAIL_PLACEHOLDER: { key: 'EMAIL_PLACEHOLDER', value: 'Email' },
  LDAP_USER_NAME_PLACEHOLDER: { key: 'LDAP_USER_NAME_PLACEHOLDER', value: 'LDAP User Name' },
  USER_ROLES_PLACEHOLDER: { key: 'USER_ROLES_PLACEHOLDER', value: 'Select User Roles' },
  USER_DETAILS_STEP: { key: 'USER_DETAILS_STEP', value: 'User Details' },
  ROLES_AND_PERMISSIONS_STEP: { key: 'ROLES_AND_PERMISSIONS_STEP', value: 'Roles and Permissions' },
  USER_INVITED_SUCCESS_MESSAGE: {
    key: 'USER_INVITED_SUCCESS_MESSAGE',
    value: 'The invitation email has been successfully sent to {{emailId}}',
  },
  LDAP_USER_ADDED_SUCCESS_MESSAGE: {
    key: 'LDAP_USER_ADDED_SUCCESS_MESSAGE',
    value: 'user created successfully',
  },
  EMPTY_FIRST_NAME_ERROR: {
    key: 'EMPTY_FIRST_NAME_ERROR',
    value: 'Please enter first name',
  },
  MAX_CHAR_LIMIT_REACHED_ERROR : {
    key: 'MAX_CHAR_LIMIT_REACHED_ERROR',
    value: 'Maximum of 45 characters allowed.'
  },
  EMPTY_EMAIL_ERROR: { key: 'EMPTY_EMAIL_ERROR', value: 'Please enter the email' },
  INVALID_EMAIL_ERROR: { key: 'INVALID_EMAIL_ERROR', value: 'Email is invalid' },
  EXISTS_EMAIL_ERROR: { key: 'EXISTS_EMAIL_ERROR', value: 'Email is already exists' },
  EMPTY_LDAP_USERNAME_ERROR: { key: 'EMPTY_LDAP_USERNAME_ERROR', value: 'Please select an user' },
  EMPTY_ROLES_ERROR: { key: 'EMPTY_ROLES_ERROR', value: 'Please select the user role or roles' },
  TEAM_PERMISSIONS_ERROR: {
    key: 'TEAM_PERMISSIONS_ERROR',
    value: 'Please select a team',
  },
  MASTER_USER_LABEL: {
    key: 'MASTER_USER_LABEL',
    value: 'Master User'
  },
};

export const UPDATE_USER_MODAL = {
  EMAIL_LABEL: { key: 'EMAIL_LABEL', value: 'Email' },
  USER_ROLES_LABEL: { key: 'USER_ROLES_LABEL', value: 'Select User Roles' },
  TEAM_PERMISSIONS_LABEL: {
    key: 'TEAM_PERMISSIONS_LABEL',
    value: 'Grant team permission',
  },
  FIRST_NAME_PLACEHOLDER: { key: 'FIRST_NAME_PLACEHOLDER', value: 'First Name' },
  LAST_NAME_PLACEHOLDER: { key: 'LAST_NAME_PLACEHOLDER', value: 'Last Name' },
  EMAIL_PLACEHOLDER: { key: 'EMAIL_PLACEHOLDER', value: 'Email' },
  USER_ROLES_PLACEHOLDER: { key: 'USER_ROLES_PLACEHOLDER', value: 'Select User Roles' },
  UPDATE_BUTTON: { key: 'UPDATE_BUTTON', value: 'Update User' },
  UPDATING_BUTTON: { key: 'UPDATING_BUTTON', value: 'Updating User' },
  USER_UPDATED_SUCCESS_MESSAGE: {
    key: 'USER_UPDATED_SUCCESS_MESSAGE',
    value: 'User Updated Successfully',
  },
  EMPTY_FIRST_NAME_ERROR: {
    key: 'EMPTY_FIRST_NAME_ERROR',
    value: 'Please enter first name',
  },
  FAILED_UPDATE_USER_TYPE_MESSAGE: {
    key: 'FAILED_UPDATE_USER_TYPE_MESSAGE',
    value: 'Failed to update user type. Please try again.'
  },
};

export const DELETE_USER_MODAL = {
  TITLE: { key: 'TITLE', value: 'Delete User' },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete User' },
  DELETING_BUTTON: { key: 'DELETING_BUTTON', value: 'Deleting User' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  DELETE_MESSAGE: {
    key: 'DELETE_MESSAGE',
    value: 'Are you sure you wish to delete the user ',
  },
  USER_DELETED_MESSAGE: { key: 'USER_DELETED_MESSAGE', value: 'User deleted successfully' },
};

export const DELETE_TEAM_MODAL = {
  TITLE: { key: 'TITLE', value: 'Delete Team' },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete Team' },
  DELETING_BUTTON: { key: 'DELETING_BUTTON', value: 'Deleting Team' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  DELETE_MESSAGE: {
    key: 'DELETE_MESSAGE',
    value: 'Are you sure you wish to delete the team ',
  },
  TEAM_UTILIZED_ERROR_MESSAGE: {
    key: 'TEAM_UTILIZED_ERROR_MESSAGE',
    value: 'Team cannot be deleted since users or templates or elements associated already',
  },
  TEAM_DELETED_MESSAGE: { key: 'TEAM_DELETED_MESSAGE', value: 'Team deleted successfully' },
};

export const LDAP_CONFIGURATION_MODAL = {
  LDAP_CONFIGURATION_TITLE: { key: 'LDAP_CONFIGURATION_TITLE', value: 'LDAP Configuration' },
  URL_LABEL: { key: 'URL_LABEL', value: 'URL' },
  PORT_LABEL: { key: 'PORT_LABEL', value: 'Port' },
  BASE_DN_LABEL: { key: 'BASE_DN_LABEL', value: 'Base DN' },
  USERNAME_IDENTIFIER_LABEL: { key: 'USERNAME_IDENTIFIER_LABEL', value: 'Username Identifier' },
  USER_DISPLAY_NAME_ATTR_LABEL: {
    key: 'USER_DISPLAY_NAME_ATTR_LABEL',
    value: 'User Display Name Attr',
  },
  USER_OBJECT_CLASS_LABEL: { key: 'USER_OBJECT_CLASS_LABEL', value: 'User Object Class' },
  USERNAME_LABEL: { key: 'USERNAME_LABEL', value: 'Username' },
  PASSWORD_LABEL: { key: 'PASSWORD_LABEL', value: 'Password' },
  UPDATING_BUTTON: { key: 'UPDATING_BUTTON', value: 'Updating' },
  UPDATE_BUTTON: { key: 'UPDATE_BUTTON', value: 'Update' },
  URL_PLACEHOLDER: { key: 'URL_PLACEHOLDER', value: 'URL' },
  PORT_PLACEHOLDER: { key: 'PORT_PLACEHOLDER', value: 'Port' },
  BASE_DN_PLACEHOLDER: { key: 'BASE_DN_PLACEHOLDER', value: 'Base DN' },
  USERNAME_IDENTIFIER_PLACEHOLDER: {
    key: 'USERNAME_IDENTIFIER_PLACEHOLDER',
    value: 'Username Identifier',
  },
  USER_DISPLAY_NAME_ATTR_PLACEHOLDER: {
    key: 'USER_DISPLAY_NAME_PLACEHOLDER',
    value: 'User Display Name Attr',
  },
  USER_OBJECT_CLASS_PLACEHOLDER: {
    key: 'USER_OBJECT_CLASS_PLACEHOLDER',
    value: 'User Object Class',
  },
  USERNAME_PLACEHOLDER: { key: 'USERNAME_PLACEHOLDER', value: 'Username' },
  PASSWORD_PLACEHOLDER: { key: 'PASSWORD_PLACEHOLDER', value: 'Password' },
  EMPTY_URL_ERROR: { key: 'EMPTY_URL_ERROR', value: 'Please enter the URL' },
  EMPTY_PORT_ERROR: { key: 'EMPTY_PORT_ERROR', value: 'Please enter the Port' },
  EMPTY_BASE_DN_ERROR: { key: 'EMPTY_BASE_DN_ERROR', value: 'Please enter the Base DN' },
  EMPTY_USERNAME_IDENTIFIER_ERROR: {
    key: 'EMPTY_USERNAME_IDENTIFIER_ERROR',
    value: 'Please enter the Username Identifier',
  },
  EMPTY_USER_DISPLAY_NAME_ATTR_ERROR: {
    key: 'EMPTY_USER_DISPLAY_NAME_ATTR_ERROR',
    value: 'Please enter the User Display Name Attr',
  },
  EMPTY_USER_OBJECT_CLASS_ERROR: {
    key: 'EMPTY_USER_OBJECT_CLASS_ERROR',
    value: 'Please enter the User Object Class',
  },
  EMPTY_USERNAME_ERROR: { key: 'EMPTY_USERNAME_ERROR', value: 'Please enter the Username' },
  EMPTY_PASSWORD_ERROR: { key: 'EMPTY_PASSWORD_ERROR', value: 'Please enter the Password' },
  LDAP_UPDATED_SUCCESS_MESSAGE: {
    key: 'LDAP_UPDATED_SUCCESS_MESSAGE',
    value: 'Ldap properties uploaded successfully'
  },
  LDAP_UPDATED_FAILURE_MESSAGE: {
    key: 'LDAP_UPDATED_FAILURE_MESSAGE',
    value: 'An error occured while trying to upload Ldap properties'
  }
};

export const UPGRADE_PLAN_MODAL = {
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  UPGRADE_BUTTON: { key: 'UPGRADE_BUTTON', value: 'Upgrade' },
  REDIRECTING_BUTTON: { key: 'REDIRECTING_BUTTON', value: 'Redirecting' },
  UPGRADE_BUTTON_TOOLTIP_TEXT: { key: 'UPGRADE_BUTTON_TOOLTIP_TEXT', value: 'Contact your admin to upgrade this account.' },
  OK_BUTTON: { key: 'OK_BUTTON', value: 'Ok' },
  REDIRECTION_FAILED_ERROR_MESSAGE: { key: 'REDIRECTION_FAILED_ERROR_MESSAGE', value: 'An error occurred while redirecting to the customer portal.' },
};

export const BILLING_PASSWORD_MODAL = {
  ENTER_PASSWORD_TITLE: { key: 'ENTER_PASSWORD_TITLE', value: 'Enter Password' },
  RE_ENTER_PASSWORD_DESCRIPTION: { key: 'RE_ENTER_PASSWORD_DESCRIPTION', value: ' Please re-enter your password to access this protected page' },
  ENTER_PASSWORD_PLACEHOLDER: { key: 'ENTER_PASSWORD_PLACEHOLDER', value: 'Enter your password' },
  INVALID_CREDENTIAL_ERROR_MESSAGE: { key: 'INVALID_CREDENTIAL_ERROR_MESSAGE', value: 'Invalid Credentials' },
  VERIFING_PASSWORD_BUTTON_TEXT: { key: 'VERIFING_PASSWORD_BUTTON_TEXT', value: 'Proceeding' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },
};

export const CHANGE_PASSWORD_MODAL = {
  CHANGE_PASSWORD_TITLE: { key: 'CHANGE_PASSWORD_TITLE', value: 'Change Password' },
  OLD_PASSWORD_LABEL: { key: 'OLD_PASSWORD_LABEL', value: 'Old Password' },
  NEW_PASSWORD_LABEL: { key: 'NEW_PASSWORD_LABEL', value: 'New Password' },
  CONFIRM_PASSWORD_LABEL: { key: 'CONFIRM_PASSWORD_LABEL', value: 'Confirm Password' },
  OLD_PASSWORD_PLACEHOLDER: { key: 'OLD_PASSWORD_PLACEHOLDER', value: 'Old Password' },
  CONFIRM_PASSWORD_PLACEHOLDER: { key: 'CONFIRM_PASSWORD_PLACEHOLDER', value: 'Confirm Password' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  CHANGING_PASSWORD_BUTTON_TEXT: { key: 'CHANGING_PASSWORD_BUTTON_TEXT', value: 'Changing' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },
  PASSWORD_UPDATE_SUCCESS_MESSAGE: { key: 'PASSWORD_UPDATE_SUCCESS_MESSAGE', value: 'Password has been successfully changed' },
  PASSWORD_VALIDATION_ERROR_MESSAGE: {
    key: 'PASSWORD_VALIDATION_ERROR_MESSAGE',
    value: "New password cannot be same as your current password"
  },
  PASSWORD_MISMATCH_ERROR_MESSAGE: {
    key: 'PASSWORD_MISMATCH_ERROR_MESSAGE',
    value: "Password does not match!"
  },
};

export const MANAGE_TEMPLATE_TAGS_MODAL = {
  MANAGE_TAGS_TITLE: { key: 'MANAGE_TAGS_TITLE', value: 'Manage Tags' },
  SAVE_TAGS_BUTTON: { key: 'SAVE_TAGS_BUTTON', value: 'Save' },
  SAVING_BUTTON: { key: 'SAVING_BUTTON', value: 'Saving' },
  CANCEL_ADDING_NEW_TAGS_BUTTON: { key: 'CANCEL_ADDING_NEW_TAGS_BUTTON', value: 'Cancel' },
  ADD_TAGS_PLACEHOLDER: { key: 'ADD_TAGS_PLACEHOLDER', value: 'Press enter to add tags' },
  TAGS_ALREADY_EXIST_ERROR_MESSAGE: {
    key: 'TAGS_ALREADY_EXIST_ERROR_MESSAGE',
    value: 'Tag already exists',
  },
  TAGS_UPDATED_SUCCESS_MESSAGE: {
    key: 'TAGS_UPDATED_SUCCESS_MESSAGE',
    value: 'Tags updated successfully!',
  },
  FAILED_TO_FETCH_TAGS_ERROR_MESSAGE: {
    key: 'FAILED_TO_FETCh_TAGS_ERROR_MESSAGE',
    value: 'An error occurred while updating tags.',
  },
  TAGS_UPDATED_SUCCESSFULL_MESSAGE: {
    key: 'TAGS_UPDATED_SUCCESSFULL_MESSAGE',
    value: 'Tags updated successfully',
  },
  TAGS_LIST_UPDATED_SUCCESSFULL_MESSAGE: {
    key: 'TAGS_LIST_UPDATED_SUCCESSFULL_MESSAGE',
    value: 'Tag list updated successfully',
  },
};

export const FONTS_UPLOAD_MODAL = {
  UPLOAD_FONT_BUTTON: { key: 'UPLOAD_FONT_BUTTON', value: 'Click to Upload' },
  FONT_EXIST_WARNING_MESSAGE: { key: 'FONT_EXIST_WARNING_MESSAGE', value: 'Font already exist!' },
  FONT_NAME_LABEL: { key: 'FONT_NAME_LABEL', value: 'Font Name' },
  FONT_NAME_PLACEHOLDER: { key: 'FONT_NAME_PLACEHOLDER', value: 'Name your Font' },
  SELECT_FONTS_PLACEHOLDER: { key: 'SELECT_FONTS_PLACEHOLDER', value: 'Select fonts...' },
  ADD_CUSTOME_FONTS_MODAL_TITLE: {
    key: 'ADD_CUSTOME_FONTS_MODAL_TITLE',
    value: 'Add Custom Fonts',
  },
  ADD_GOOGLE_FONTS_MODAL_TITLE: { key: 'ADD_GOOGLE_FONTS_MODAL_TITLE', value: 'Google fonts' },
  CANCEL_FONT_UPLOAD_BUTTON: { key: 'CANCEL_FONT_UPLOAD_BUTTON', value: 'Cancel' },
  SAVING_BUTTON: { key: 'SAVING_BUTTON', value: 'Saving' },
  SAVE_UPLOADED_FONT_BUTTON: { key: 'SAVE_UPLOADED_FONT_BUTTON', value: 'Save' },
  FONTS_UPLOADED_SUCCESS_MESSAGE: {
    key: 'FONTS_UPLOADED_SUCCESS_MESSAGE',
    value: 'Fonts Uploaded Successfully',
  },
  MOVE_TO_UPLOAD_SECTION_BUTTON: { key: 'MOVE_TO_UPLOAD_SECTION_BUTTON', value: 'Back' },
  REGULAR_FONT_STYLE: { key: 'REGULAR_FONT_STYLE', value: 'Regular' },
  Bold_FONT_STYLE: { key: 'Bold_FONT_STYLE', value: 'Bold' },
  Italic_FONT_STYLE: { key: 'Italic_FONT_STYLE', value: 'Italic' },
  Bold_Italic_FONT_STYLE: { key: 'Bold_Italic_FONT_STYLE', value: 'Bold Italic' },
};

export const TRANSACTIONS_VARIABLES_DETAILS_MODAL = {
  MISSED_VARIABLE_LIST_MODAL_TITLE: {
    key: 'MISSED_VARIABLE_LIST_MODAL_TITLE',
    value: 'Missed Variable List'
  },
  TEMPLATE_VARIABLE_DETAILS_MODAL_TITLE: {
    key: 'TEMPLATE_VARIABLE_DETAILS_MODAL_TITLE',
    value: 'Template Variable Details'
  },
  NAME_VARIABLE_COLUMN_TITLE: {
    key: 'NAME_VARIABLE_COLUMN_TITLE',
    value: 'Name'
  },
  TYPE_VARIABLE_COLUMN_TITLE: {
    key: 'TYPE_VARIABLE_COLUMN_TITLE',
    value: 'Type'
  },
  MAX_LENGTH_VARIABLE_COLUMN_TITLE: {
    key: 'MAX_LENGTH_VARIABLE_COLUMN_TITLE',
    value: 'Max Length'
  },
  DATE_FORMAT_NOTE: {
    key: 'DATE_FORMAT_NOTE',
    value: 'Use (DD-MM-YYYY) as default format for the date variable'
  },
  MOBILE_FORMAT_NOTE: {
    key: 'MOBILE_FORMAT_NOTE',
    value: 'Use text as the format for Mobile Number with country code'
  },
  NOTE_TITLE: {
    key: 'NOTE_TITLE',
    value: 'Note:'
  }
};

export const PREVIEW_MODAL = {
  RESPONSE_ERROR: {
    key: 'RESPONSE_ERROR',
    value: 'Please try again later'
  },
}

//Mailroom
export const MAILROOM_VARIABLES_DETAILS_MODAL = {
  TAG_DETAILS_MODAL_TITLE: {
    key: 'TAG_DETAILS_MODAL_TITLE',
    value: 'Tag Details'
  },
  TAG_ID_COLUMN_TITLE: {
    key: 'TAG_ID_COLUMN_TITLE',
    value: 'Tag ID'
  },
  TAG_NAME_VARIABLE_TITLE: {
    key: 'TAG_NAME_VARIABLE_TITLE',
    value: 'Tag Name'
  },
};

//PDF channel transactions variable details
export const GENERATE_PDF_VARIABLES_DETAILS_MODAL = {
  GENERATE_PDF_MODAL_TITLE: {
    key: 'GENERATE_PDF_MODAL_TITLE',
    value: 'Generate PDF'
  },
  GENERATING_PDF_MESSAGE: {
    key: 'GENERATING_PDF_MESSAGE',
    value: 'Generating PDF'
  },
  PDF_GENERATED_SUCCESSFULLY_SUCCESS_MESSAGE: {
    key: 'PDF_GENERATED_SUCCESSFULLY_SUCCESS_MESSAGE',
    value: 'PDF Generated Successfully'
  },
}

export const TRANSACTIONS_VARIABLE_UPLOAD_RESULT_MODAL = {
  SL_NO_COLUMN_TITLE: {
    key: 'SL_NO_COLUMN_TITLE',
    value: 'Sl.No'
  },
  STATUS_COLUMN_TITLE: {
    key: 'STATUS_COLUMN_TITLE',
    value: 'Status'
  },
  EMPTY_EXCEL_FILE_ERROR_MESSAGE: {
    key: 'EMPTY_EXCEL_FILE_ERROR_MESSAGE',
    value: 'Uploaded empty excel file !'
  },
  UPLOADED_MESSAGE: {
    key: 'UPLOADED_MESSAGE',
    value: 'Uploaded'
  },
  UPLOAD_EXCEL_FILE_MESSAGE: {
    key: 'UPLOAD_EXCEL_FILE_MESSAGE',
    value: 'file, please upload an excel file'
  },
  TRY_AGAIN_BUTTON: {
    key: 'TRY_AGAIN_BUTTON',
    value: 'Try Again'
  },
  REQUEST_ID_COLUMN_TITLE: {
    key: 'REQUEST_ID_COLUMN_TITLE',
    value: 'Request ID'
  },
  FAILURE_REQUEST_STATUS: {
    key: 'FAILURE_REQUEST_STATUS',
    value: 'failure'
  },
  SUCCESS_REQUEST_STATUS: {
    key: 'SUCCESS_REQUEST_STATUS',
    value: 'success'
  },
  PROCESSING_REQUEST_STATUS: {
    key: 'PROCESSING_REQUEST_STATUS',
    value: 'processing'
  },
};

//PDF channel transactions variable upload results
export const GENERATE_PDF_VARIABLE_UPLOAD_RESULT_MODAL = {
  PDF_DOWNLOADED_SUCCESS_MESSAGE: {
    key: 'PDF_DOWNLOADED_SUCCESS_MESSAGE',
    value: 'Generated PDF downloaded successfully'
  },
  GENERATE_MORE_PDF_MESSAGE: {
    key: 'GENERATE_MORE_PDF_MESSAGE',
    value: 'Generate more PDF'
  },
  PDF_GENERATION_ERROR_MESSAGE: {
    key: 'PDF_GENERATION_ERROR_MESSAGE',
    value: 'Unable to generate PDF'
  },
  LIMIT_EXCEEDED_TITLE: {
    key: 'LIMIT_EXCEEDED_TITLE',
    value: 'Limit Exceeded',
  },
  LIMIT_EXCEEDED_DESCRIPTION: {
    key: 'LIMIT_EXCEEDED_DESCRIPTION',
    value: "You've reached your plan's document creation limit. Only some documents (based on your limit) were processed and are downloaded here.",
  }
}

//Mail channel transactions variable upload results
export const TRIGGER_EMAILS_VARIABLE_UPLOAD_RESULT_MODAL = {
  MAIL_REQUEST_STATUS_MODAL_TITLE: {
    key: 'MAIL_REQUEST_STATUS_MODAL_TITLE',
    value: 'Mail Request Status'
  },
  EMAIL_REQUEST_FAILED_ERROR_MESSAGE: {
    key: 'EMAIL_REQUEST_FAILED_ERROR_MESSAGE',
    value: 'Email request failed'
  },
  EMAIL_SENT_SUCCESS_MESSAGE: {
    key: 'EMAIL_SENT_SUCCESS_MESSAGE',
    value: 'Email sent successfully'
  },
  SENDING_EMAIL_MESSAGE: {
    key: 'SENDING_EMAIL_MESSAGE',
    value: 'Sending email...'
  },
  SEND_MORE_EMAIL_MESSAGE: {
    key: 'SEND_MORE_EMAIL_MESSAGE',
    value: 'Send more email'
  },
  UNABLE_TO_SEND_EMAIL_ERROR_MESSAGE: {
    key: 'UNABLE_TO_SEND_EMAIL_ERROR_MESSAGE',
    value: 'Unable to send email' 
  },
  TO_ADDRESS_INVALID_ERROR_MESSAGE: {
    key: 'TO_ADDRESS_INVALID_ERROR_MESSAGE',
    value: 'To email address is invalid'
  }
}

//Message channel transactions variable upload results
export const SEND_SMS_VARIABLE_UPLOAD_RESULT_MODAL = {
  MESSAGE_STATUS_MODAL_TITLE: {
    key: 'MESSAGE_STATUS_MODAL_TITLE',
    value: 'Message Status'
  },
  SMS_SENT_SUCCESS_MESSAGE: {
    key: 'SMS_SENT_SUCCESS_MESSAGE',
    value: 'SMS has been sent successfully'
  },
  SMS_SENT_ERROR_MESSAGE: {
    key: 'SMS_SENT_ERROR_MESSAGE',
    value: 'Unable to send SMS'
  },
}

//Call channel transactions variable upload results
export const INITIATE_PHONE_CALLS_VARIABLE_UPLOAD_RESULT_MODAL = {
  CALL_INITIATED_SUCCESS_MESSAGE: {
    key: 'CALL_INITIATED_SUCCESS_MESSAGE',
    value: 'Call initiated successfully'
  },
  CALL_INITIATED_ERROR_MESSAGE: {
    key: 'CALL_INITIATED_ERROR_MESSAGE',
    value: 'Unable to initiate call'
  },
}

//Whatsapp channel transactions variable upload results
export const SEND_WHATSAPP_VARIABLE_UPLOAD_RESULT_MODAL = {
  WHATSAPP_SENT_SUCCESS_MESSAGE: {
    key: 'WHATSAPP_SENT_SUCCESS_MESSAGE',
    value: 'Whatsapp message has been sent successfully'
  },
  WHATSAPP_SENT_ERROR_MESSAGE: {
    key: 'WHATSAPP_SENT_ERROR_MESSAGE',
    value: 'Unable to send whatsapp message'
  },
}

export const CREATE_NEW_ELEMENT_MODAL = {
  NEW_ELEMENT_TITLE: { key: 'NEW_ELEMENT_TITLE', value: 'Create a new element' },
  ELEMENT_NAME_LABEL: { key: 'ELEMENT_NAME_LABEL', value: 'Provide a name for your element' },
  TEMPLATE_NAME_PLACEHOLDER: { key: 'TEMPLATE_NAME_PLACEHOLDER', value: 'Name your template' },
  CATEGORY_LABEL: { key: 'CATEGORY_LABEL', value: 'Category Name' },
  CATEGORY_PLACEHOLDER: { key: 'CATEGORY_PLACEHOLDER', value: 'Name your category' },
  ADD_NEW_ACTION: { key: "ADD_NEW_ACTION", value: 'Add new' },
  CATEGORY_NAME_LABEL: { key: 'CATEGORY_NAME_LABEL', value: "Category Name" },
  CATEGORY_NAME_PLACEHOLDER: { key: 'CATEGORY_NAME_PLACEHOLDER', value: "Name your category" },
  CREATE_BUTTON: { key: 'CREATE_BUTTON', value: 'Create' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  SAVE_BUTTON: { key: 'SAVE_BUTTON', value: 'Save' },
  CREATE_LOADING: { key: 'CREATE_LOADING', value: 'Creating' },
  SAVE_LOADING: { key: 'SAVE_LOADING', value: 'Saving' },
  ENTER_VALID_NAME_WARNING_MESSAGE: { key: "ENTER_VALID_NAME_WARNING_MESSAGE", value: 'Please enter a valid element name' },
  SELECT_TEAM_LABEL:{ key: "SELECT_TEAM_LABEL", value: 'Select a team for your element' },
  SELECT_TEAM_PLACEHOLDER:{ key: "SELECT_TEAM_PLACEHOLDER", value: 'Select a team' },
  CREATE_REFERENCED_ELEMENT_TITLE:{key:'CREATE_REFERENCED_ELEMENT_TITLE',value:'Create a new reference element'},
  ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE:{key:"ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE",value:"Element name already exists, try different one!"},
  CHAR_LIMIT_EXCEEDED_ERROR: { key: 'CHAR_LIMIT_EXCEEDED_ERROR', value: 'Maximum of {{charLimitLength}} characters allowed' },
  DESIGN_NEW_REUSABLE_SECTION_TITLE: { key: 'DESIGN_NEW_REUSABLE_SECTION_TITLE', value: 'Design a new reusable section' },
}

export const CREATE_NEW_BLOCK_MODAL = {
  BLOCK_NAME_LABEL: { key: 'BLOCK_NAME_LABEL', value: "Provide a unique name for your design" },
  BLOCK_NAME_PLACEHOLDER: { key: 'BLOCK_NAME_PLACEHOLDER', value: "Name your template" },
  SECTION_CREATION_ERROR_MESSAGE: {
    key: 'SECTION_CREATION_ERROR_MESSAGE',
    value:
      'Unable to create the section. Please try again'
  },
  SECTION_NAME_UNSUPPORTED_CHARS: {
    key: 'SECTION_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
}

export const BULK_FONT_UPLOAD_MODAL = {
  INVALID_FILE_ERROR_MESSAGE: { key: 'INVALID_FILE_ERROR_MESSAGE', value: 'Sorry, we support only .ttf files' },
  UPLOAD_FAILED_ERROR_MESSAGE: { key: 'UPLOAD_FAILED_ERROR_MESSAGE', value: 'File upload failed' }, 
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' }, 
  UPLOAD_BUTTON: { key: 'UPLOAD_BUTTON', value: 'Upload fonts' },
  DRAG_AND_DROP_TEXT: { key: 'DRAG_AND_DROP_TEXT', value: 'Drag & Drop files here' },
  UNRECOGNIZABLE_FILES_ERROR_MESSAGE: { key: 'UNRECOGNIZABLE_FILES_ERROR_MESSAGE', value: 'Unrecognizable files' },
  UPLOAD_SUCCESS_MESSAGE: { key: 'UPLOAD_SUCCESS_MESSAGE', value: 'Fonts Uploaded Successfully' },
  BACK_BUTTON: { key: 'BACK_BUTTON', value: 'Back' },
};

export const EMAIL_SUBJECT_MODAL = {
  EMAIL_SUBJECT_LABEL: { key: 'EMAIL_SUBJECT_LABEL', value: 'Subject of Email' },
  EMAIL_SUBJECT_PLACEHOLDER: { key: 'EMAIL_SUBJECT_PLACEHOLDER', value: 'Subject of Email' },
  EMPTY_EMAIL_SUBJECT_ERROR_MESSAGE: { key: 'EMPTY_EMAIL_SUBJECT_ERROR_MESSAGE', value: 'Please fill out a subject for the email' },
  CANCEL_ENTERED_EMAIL_SUBJECT_BUTTON: { key: 'CANCEL_ENTERED_EMAIL_SUBJECT_BUTTON', value: 'Cancel' },
  SAVE_ENTERED_EMAIL_SUBJECT_BUTTON: { key: 'SAVE_ENTERED_EMAIL_SUBJECT_BUTTON', value: 'Save' },
  SAVING_ENTERED_EMAIL_SUBJECT_BUTTON: { key: 'SAVING_ENTERED_EMAIL_SUBJECT_BUTTON', value: 'Saving' },
  UPDATE_EMAIL_SUBJECT_SUCCESSFUL: { key: 'UPDATE_EMAIL_SUBJECT_SUCCESSFUL', value: 'Subject updated successfully!!' },
  UPDATE_EMAIL_SUBJECT_FAILURE: { key: 'UPDATE_EMAIL_SUBJECT_FAILURE', value: 'Unable to update subject, Please try again later'},
  MAX_CHAR_EXCEEDED_ERROR: { key: 'MAX_CHAR_EXCEEDED_ERROR', value: 'Maximum of {{maxCharLength}} characters allowed.' },
}

export const ADD_EMAIL_ATTACHMENT_MODAL = {
  FILE_UPLOAD_SUCCESS: { key: 'FILE_UPLOAD_SUCCESS', value: 'file uploaded successfully' },
  UNABLE_TO_UPLOAD_ERROR_MESSAGE: { key: 'UNABLE_TO_UPLOAD_ERROR_MESSAGE', value: 'Unable to upload' },
  EMAIL_ATTACHMENT_TITLE: { key: 'EMAIL_ATTACHMENT_TITLE', value: 'Add Email Attachment' },
  CHOOSE_PRINT_HEADER: { key: 'HEADER', value: 'Choose a Print template' },
  ADD_ATTACHMENT_BUTTON: { key: 'ADD_ATTACHMENT_BUTTON', value: 'Add as attachment' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  UPLOAD_FILE_HEADER: { key: 'UPLOAD_FILE', value: 'Upload a file from your computer' },
  DRAG_FILE_ACTION: { key: 'DRAG_FILE_ACTION', value: 'Click or drag file to this area to upload' },
  EDITABLE_TEMPLATE_ATTACHED: { key: 'EDITABLE_TEMPLATE_ATTACHED', value: 'An Editable template already attached' },
  ONLY_PDF_ALLOWED: { key: 'ONLY_PDF_ALLOWED', value: 'Only PDF files are allowed!' }, 
};

export const ATTACHMENT_PREVIEW_MODAL = {
  FILE_NAME_PLACEHOLDER: { key: 'FILE_NAME_PLACEHOLDER', value: 'File name for attachment' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  ADD_ATTACHMENT_BUTTON: { key: 'ADD_ATTACHMENT_BUTTON', value: 'Add as attachment' },
};

export const MULTIPLE_FILE_UPLOAD_MODAL = {
  CANCEL_BUTTON: {
    key: 'CANCEL_BUTTON',
    value: 'Cancel',
  },
  UPLOAD_ELEMENT_BUTTON: {
    key: 'UPLOAD_ELEMENT_BUTTON',
    value: 'Upload Element',
  },
  UPLOAD_ELEMENT_TITLE: {
    key: 'UPLOAD_ELEMENT_TITLE',
    value: 'Upload ElementS',
  },
  DRAG_AND_DROP_ACTION: {
    key: 'DRAG_AND_DROP_ACTION',
    value: 'Drag & Drop files here',
  },
  UNABLE_TO_UPLOAD_FILE_ERROR_MESSAGE: {
    key: 'UNABLE_TO_UPLOAD_FILE_ERROR_MESSAGE',
    value: 'We were not able to upload some images',
  },
  SAVE_BUTTON: {
    key: 'SAVE_BUTTON',
    value: 'Save',
  },
  UPLOAD_SAVING_TEXT: {
    key: 'UPLOAD_SAVING_TEXT',
    value: 'Saving',
  },
  CATEGORY_NAME_LABEL: {
    key: 'CATEGORY_NAME_LABEL',
    value: 'Category Name',
  },
  CATEGORY_NAME_PLACEHOLDER: {
    key: 'CATEGORY_NAME_PLACEHOLDER',
    value: 'Name your category',
  },
  CATEGORY_LABEL: {
    key: 'CATEGORY_LABEL',
    value: 'Category',
  }, 
  ADD_NEW_ACTION: {
    key: 'ADD_NEW_ACTION',
    value: 'Add new',
  },
  SELECT_CATEGORY_PLACEHOLDER: {
    key: 'SELECT_CATEGORY_PLACEHOLDER',
    value: 'Select a category',
  },
  NOT_SUPPORTED_FILE_UPLOADED_ERROR_MESSAGE: {
    key: 'NOT_SUPPORTED_FILE_UPLOADED_ERROR_MESSAGE',
    value: 'Please upload only files of extension ',
  },
}

export const SEND_TEST_EMAIL_MODAL = {
  TAG_ALREADY_EXISTS_ERROR_MESSAGE: { key: 'TAG_ALREADY_EXISTS_ERROR_MESSAGE', value: 'Tag already exists' },
  INVALID_EMAIL_ERROR_MESSAGE: { key: 'INVALID_EMAIL_ERROR_MESSAGE', value: 'Email is invalid' },
  EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE: { key: 'EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE', value: 'Please add recipients for test email' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  SEND_MAIL_BUTTON: { key: 'SEND_MAIL_BUTTON', value: 'Send Test Mail' },
  SENDING_MAIL_BUTTON_TEXT: { key: 'SENDING_MAIL_BUTTON_TEXT', value: 'Sending Test Mail' },
  SEND_TEST_MAIL_TO_LABEL: { key: 'SEND_TEST_MAIL_TO_LABEL', value: ' Send Test Mail to' },
  ADD_MAIL_ADDRESS_PLACEHOLDER: { key: 'ADD_MAIL_ADDRESS_PLACEHOLDER', value: 'Press enter to add mail addresses' },
  ENTER_PASSWORD_LABEL: { key: 'ENTER_PASSWORD_LABEL', value: 'Password' },
  ENTER_PASSWORD_PLACEHOLDER: { key: 'ENTER_PASSWORD_PLACEHOLDER', value: 'Enter password for protecting attachments' },
  SEND_TEST_EMAIL_SUCCESS: { key: 'SEND_TEST_EMAIL_SUCCESS', value: 'Test email sent successfully!!' },
  SEND_TEST_EMAIL_FAILURE: { key: 'SEND_TEST_EMAIL_FAILURE', value: 'Unable to send test email, Please try again after some time!!' }
}

export const SEND_EMAIL_MODAL = {
  EMAIL_ALREADY_EXISTS_ERROR: { key: 'EMAIL_ALREADY_EXISTS_ERROR', value: 'Email already exists' },
  EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE: { key: 'EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE', value: 'Please add recipients' },
  SEND_EMAIL_TO_LABEL: { key: 'SEND_EMAIL_TO_LABEL', value: ' Send Email to' },
  SEND_EMAIL_SUCCESS: { key: 'SEND_EMAIL_SUCCESS', value: 'Email sent successfully!!' },
  SEND_EMAIL_FAILURE: { key: 'SEND_EMAIL_FAILURE', value: 'Unable to send email, Please try again after some time!!' },
  SEND_EMAIL_TITLE: { key: 'SEND_EMAIL_TITLE', value: "Send Email" },
  TO_LABEL: { key: 'TO_LABEL', value: 'To' }, 
  CC_LABEL: { key: 'CC_LABEL', value: 'Cc' },
  SEND_BUTTON: { key: 'SEND_BUTTON', value: 'Send' },
  SENDING_EMAIL_BUTTON: { key: 'SENDING_EMAIL_BUTTON', value: 'Sending' },

}

export const CONFIRMATION_PAGE_MODAL = {
  ATTACH_BUTTON : { key: 'ATTACH_BUTTON', value: 'ATTACH' },
  CLONE_PAGES_BUTTON : { key: 'CLONE_PAGES_BUTTON', value: 'CLONE PAGES' },
  CLONE_SECTION_BUTTON : { key: 'CLONE_SECTION_BUTTON', value: 'CLONE SECTION' },
  ATTACH_PAGE_DESCRIPTION : { key: 'ATTACH_PAGE_DESCRIPTION', value: ' To add read-only pages to this design and maintain the content in a centralized place' },
  ATTACH_SECTION_DESCRIPTION : { key: 'ATTACH_SECTION_DESCRIPTION', value: ' To add read-only section to this design and maintain the content in a centralized place' },
  CLONE_PAGE_DESCRIPTION : { key: 'CLONE_PAGE_DESCRIPTION', value: 'To clone the pages and edit it within this document template locally' },
  CLONE_SECTION_DESCRIPTION : { key: 'CLONE_SECTION_DESCRIPTION', value: 'To clone the section and edit it within this document template locally' },
  PAGE_MODAL_TITLE:{ key: 'PAGE_MODAL_TITLE', value: 'WHAT WOULD YOU LIKE TO DO WITH THE DRAGGED PAGES??' },
  SECTION_MODAL_TITLE:{ key: 'SECTION_MODAL_TITLE', value: 'WHAT WOULD YOU LIKE TO DO WITH THE DRAGGED SECTION??' },
  WARNING_MESSAGE:{ key: 'WARNING_MESSAGE', value:'Failed to Perform Operation. Please try again'},
  HEIGHT_DOES_NOT_FIT_CONTENT: {
    key: 'HEIGHT_DOES_NOT_FIT_CONTENT',
    value: 'Some blocks are of height greater than the design area. Kindly retry after altering the block heights!!'
  },
  GRID_SELECTION: { key: 'GRID_SELECTION', value: 'GRID SELECTION'},
  ROWS: { key: 'ROWS', value: 'Rows'},
  COLUMNS: { key: 'COLUMNS', value: 'Columns'},
  TOC_SETTINGS: { key: 'TOC_SETTINGS', value: 'Table of contents settings'},
  TOC_SETTINGS_SUCCESS_MESSAGE: { key: 'TOC_SETTINGS_SUCESS_MESSAGE', value: 'Your configurations are saved successfully'},
  TOC_SETTINGS_ERROR_MESSAGE: { key: 'TOC_SETTINGS_ERROR_MESSAGE', value: 'Failed to save your configurations'},
  HEADER_FOOTER_NOT_ALLOWED :{ key : 'HEADER_FOOTER_NOT_ALLOWED', value: 'Header or Footer sections cannot be added in the design area.'},
  ONLY_TEXT_CREATIVE_BLOCK: { key : 'ONLY_TEXT_CREATIVE_BLOCK', value: 'Only Text and Creative sections are supported in the design area.'},
  SECTIONS_WITHOUT_VARIABLES: { key : 'SECTIONS_WITHOUT_VARIABLES', value : 'Sections with variables are not supported in the design area.'}
}

// Storage Configuration
export const STORAGE_CONFIG_MODAL = {
  ACCESS_KEY_LABEL: { key: 'ACCESS_KEY_LABEL', value: 'Access Key' },
  SECRET_KEY_LABEL: { key: 'SECRET_KEY_LABEL', value: 'Secret Key' },
  FORM_FIELD_REQUIRED_ERROR_MESSAGE: { key: 'FORM_FIELD_REQUIRED_ERROR_MESSAGE', value: 'This field is required' },
  NO_CHANGES_MADE_WARNING: { key: 'NO_CHANGES_MADE_WARNING', value: 'No changes were made.' },
  UPDATE_TITLE: { key: 'UPDATE_TITLE', value: 'Update' },
  CONFIG_TITLE: { key: 'CONFIG_TITLE', value: 'Configuration' },
  SUBMIT_BUTTON: { key: 'SUBMIT_BUTTON', value: 'Submit' },
}

export const TRANSACTION_COMPLETE_MODAL = {
  TRANSACTION_COMPLETE_TITLE: { key: 'TRANSACTION_COMPLETE_TITLE', value: 'Transaction Complete' },
  TRANSACTION_MODAL_OK_BUTTON: { key: 'TRANSACTION_MODAL_OK_BUTTON', value: 'OK' },
  TRANSACTION_MESSAGE: { key: 'TRANSACTION_MESSAGE', value: 'Congratulations! You’ve successfully finalized the document, and it’s now generated!  This document is all set and ready to go, so no more changes can be made.' },
  TRANSACTION_MESSAGE_EMAIL: { key: 'TRANSACTION_MESSAGE_EMAIL', value: 'Congratulations! You’ve successfully finalized the document, and it’s now sent along with the pending email as an attachment!' },
 };
export const QUILL_EDITOR_MODAL = {
  MAXIMUM_CHAR_LIMIT_ERROR: {
    key: 'MAXIMUM_CHAR_LIMIT_ERROR',
    value: 'Maximum of {{maxCharLength}} characters allowed.',
  },
  CANCEL_BUTTON_TEXT: { key: 'CANCEL_BUTTON_TEXT', value: 'Cancel' },
  SAVE_BUTTON_TEXT: { key: 'SAVE_BUTTON_TEXT', value: 'Save' },
  SAVING_BUTTON_TEXT: { key: 'SAVING_BUTTON_TEXT', value: 'Saving ...' },
};

export const SETUP_ERROR_MODAL = {
  CLOSE_BUTTON: {
    key: 'CLOSE_BUTTON',
    value: 'Close'
  },
  ERROR_MESSAGE: {
    key: 'ERROR_MESSAGE',
    value: 'Sorry, your storage account is not setup yet. Kindly contact support to complete your account setup.'
  },
}